<template>
  <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 300 300" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="4">
    <path d="M97.3,86L24.8,55.9h0l43.8-18.8,47.6,15.6M193.7,295l41.2-24-12.4-88.2M202.8,99.1L170.9,5l-41.2,24M234,176.7l41.2-24-72.4-53.6-41.2,24M97.3,85.9L24.8,55.9l52.4,88.9-12.9,75.6,64.8-2.1,64.6,76.8-12.4-90.1,52.8-28.1-72.4-53.6-32-94.1-32.4,57h0Z" />
  </svg>
</template>
